import { useInfiniteQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import {
  ServiceLine,
} from '@/shared/types/serviceLineTypes';
import { PaginatedResponse } from '@/shared/types/responseTypes';

/** Infinite scroll fetch for dashboard-style load-more. */
export const useInfiniteCustomerServiceLines = (customerId: string | undefined, searchQuery: string | undefined) => {
  return useInfiniteQuery({
    queryKey: ['customer-service-lines-infinite', customerId, searchQuery],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const response = await apiClient.get<PaginatedResponse<ServiceLine>>(
        `/api/v1/customers/${customerId}/service-lines`,
        {
          params: {
            page: pageParam,
            includeDataUsage: true,
            includeActiveAlerts: true,
            searchQuery
          }
        }
      );
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.isLastPage ? undefined : lastPageParam + 1,
    enabled: !!customerId,
  });
};